import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Style } from '../domain/styles/styleTypes';

interface TargetCollection {
  customer: string;
  id?: string;
  name: string;
}

export interface BatchModeState {
  baseMockupId: string;
  isEnabled: boolean;
  selectedStyles: Style[];
  targetCollection: TargetCollection;
}

const initialState: BatchModeState = {
  baseMockupId: '',
  isEnabled: false,
  selectedStyles: [],
  targetCollection: {
    id: '',
    name: '',
    customer: '',
  },
};

export const batchModeSlice = createSlice({
  name: 'batchMode',
  initialState,
  reducers: {
    enableBatchMode(state) {
      state.isEnabled = true;
    },
    disableBatchMode(state) {
      state.isEnabled = false;
      state.selectedStyles = [];
      state.targetCollection = {
        id: '',
        name: '',
        customer: '',
      };
    },
    setSelectedStyles(state, action: PayloadAction<any[]>) {
      state.selectedStyles = action.payload;
    },
    setTargetCollection(state, action: PayloadAction<TargetCollection>) {
      state.targetCollection = action.payload;
    },
    setBaseMockupId(state, action: PayloadAction<string>) {
      state.baseMockupId = action.payload;
    },
  },
});

export const {
  enableBatchMode,
  disableBatchMode,
  setSelectedStyles,
  setTargetCollection,
  setBaseMockupId,
} = batchModeSlice.actions;

export const batchModeReducer = batchModeSlice.reducer;
